// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__1oq2R"};